import { Dispatch } from "redux";
import { GET_PARAMS } from "./paramHelper";

export const RECEIVE_FEED_OWNER_DETAIL_USERS = "RECEIVE_FEED_OWNER_DETAIL_USERS";
export const RECEIVE_FEED_OWNER_DETAIL_ROWS = "RECEIVE_FEED_OWNER_DETAIL_ROWS";

export interface FeedOwnerDetailRow {
  user: string;
  client_name?: string;
  country?: string;
  version?: string;
  feed_type?: string;
  feed_created_date?: string;
  feed_start_date?: string;
  feed_end_date?: string;
  paused?: boolean;
  feed_status?: string;
  has_brand_filter?: boolean;
  brand_filter_raw?: string;
  created_within_last_30_days?: boolean;
  last_progress_logical_date?: string;
  last_progress_activity_at?: string;
  delivery_integration?: string;
  misc_json?: string;
  [key: string]: any;
}

export const fetchFeedOwnerDetailUsers =
  (token: string) => async (dispatch: Dispatch) => {
    const resp = await fetch("/api/feed_owner_report_detail/users", GET_PARAMS(token));
    if (!resp.ok) {
      throw new Error(`Failed to fetch feed owner detail users: ${resp.status}`);
    }
    const { users }: { users: string[] } = await resp.json();
    return dispatch({ type: RECEIVE_FEED_OWNER_DETAIL_USERS, users });
  };

export const fetchFeedOwnerDetailRows =
  (token: string, user: string) => async (dispatch: Dispatch) => {
    const resp = await fetch(
      `/api/feed_owner_report_detail/?user=${encodeURIComponent(user)}`,
      GET_PARAMS(token)
    );
    if (!resp.ok) {
      throw new Error(`Failed to fetch feed owner detail rows: ${resp.status}`);
    }
    const { rows }: { rows: FeedOwnerDetailRow[] } = await resp.json();
    return dispatch({ type: RECEIVE_FEED_OWNER_DETAIL_ROWS, user, rows });
  };
